export const OverviewSections = {
  FACTORS: 'factors',
  PAI_INDICATORS: 'pai-indicators',
};
